import React, { useState } from "react";
import oauth from "../utils/oauth";
import AlertComponentWrapper from "./ProcessosFormHandler/AlertComponentWrapper";

const AllIframesComponent = ({ name }) => {
  const [renderIFrame, setRenderIFrame] = useState(true);

  const style = {
    frameborder: "0px",
    width: "100%",
    border: "none",
    height: "auto",
    minHeight: "92vh",
  };

  const stylenew = {
    ...style,
    minHeight: "80vh",
    padding: "1rem 2rem",
    margin: "1rem",
    borderRadius: "20px",
    backgroundColor: "#fff",
    boxShadow: "0px 4px 30px #6d6d6d26",
  };

  const token = oauth.getAccessToken();
  const authtoken = "&Authorization=" + token;
  
  const getUrl = () => {
    switch (name) {
      case "gdpr":
        return `/GDPR/main.jsp?uniktheme=uniksystem&app=${name}&menu=tasks${authtoken}`;
      case "bpm":
        return `/iFlow/main.jsp?uniktheme=uniksystem&app=${name}&menu=tasks${authtoken}`;
      case "compliance":
        return `/Compliance/main.jsp?uniktheme=uniksystem&app=${name}&menu=tasks${authtoken}`;
      case "gai":
        return `/GAI/main.jsp?uniktheme=uniksystem&app=${name}&menu=tasks${authtoken}`;
      case "rh":
      case "portalrh":
        return `/portal/index.php?authtoken=${token}`;
      default:
        return "";
    }
  };

  const haveFrame = window.location.href.includes("/frame");

  const handleIframeLoad = () => {
    if (name === "portalrh" || name === "rh") {
      const iframe = document.getElementById("portalrh") || document.getElementById("rh");
      const iframeDocument = iframe.contentDocument || iframe.contentWindow.document;
      const rootDiv = iframeDocument.getElementById("login-overlay");
      if (rootDiv) {
        setRenderIFrame(false);
      } else {
        setRenderIFrame(true);
      }
      if(haveFrame)iframe.style.display = "block";
      else iframe.style.display = "none";
    } else {
      setRenderIFrame(true);
    }
  };

  const url = getUrl();

  return (
    <>
      {renderIFrame && url ? (
        <iframe
          id={name}
          src={url}
          style={name === "portalrh" ? stylenew : style}
          title="app"
          onLoad={handleIframeLoad}
        />
      ) : (
        haveFrame && <AlertComponentWrapper name="general.errorNoLoginPortal" />
      )}
    </>
  );
};

export default AllIframesComponent;